import { render } from "./ProductSalesReport.vue?vue&type=template&id=78f3f1d4&scoped=true"
import script from "./ProductSalesReport.vue?vue&type=script&lang=js"
export * from "./ProductSalesReport.vue?vue&type=script&lang=js"

import "./ProductSalesReport.vue?vue&type=style&index=0&id=78f3f1d4&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f3f1d4"]])

export default __exports__